import { ThemeContext } from '@benzinga/themetron';
import { ValueFormatterParams } from 'ag-grid-community';
import React from 'react';
import { AdvancedColDef, absColDef } from '../helpers';
import { hexToRGBA } from '@benzinga/utils';

const RelativeVolumeComponentRenderer = (params: ValueFormatterParams) => {
  const theme = React.useContext(ThemeContext);
  return (
    <div
      style={{
        backgroundColor:
          params.value > 100
            ? hexToRGBA(theme.colors.statistic.positive, 0.8)
            : params.value > 50
              ? hexToRGBA(theme.colors.statistic.neutral, 0.8)
              : hexToRGBA(theme.colors.statistic.negative, 0.8),
        color:
          params.value > 100
            ? theme.colors.accentForeground
            : params.value > 50
              ? theme.colors.backgroundActive
              : theme.colors.brandForeground,
        textAlign: 'center',
      }}
    >
      {params.value}
    </div>
  );
};

export const PercentNumberBackgroundColorColDef = (colDef: AdvancedColDef): AdvancedColDef => ({
  cellRenderer: RelativeVolumeComponentRenderer,
  ...colDef,
  ...absColDef(colDef),
});
